
import { defineComponent, ref } from "vue";
export default defineComponent({
    name: "App",
    setup() {
        const visible = ref(false);
        return {
            visible,
        };
    },
});
